<template>
<v-dialog v-model="dialog" scrollable max-width="980px" transition="dialog-transition" persistent :fullscreen="$vuetify.breakpoint.smAndDown" @keydown.esc="emitExit()">
    <v-card flat class="pa-3 hotel-modal" id="hotel-media" min-height="350px">
        <v-card-title>
            <div class="hotel-modal-header pl-2">
                Media
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>

        </v-card-title>

        <v-card-text class="scroll-card">

            <div id="dropzone" class="d-none" ref="dragzone">
                <div class="text-dropzone">{{ $t('hotel.media.message_drop') }}</div>
            </div>
            <div class="justify-space-between align-center d-flex py-2">
                <div>
                    {{ $t('hotel.media.message_drag_files') }}
                </div>
                <v-btn color="primary">
                    <input type="file" ref="fileInput" accept="image/png, image/jpeg" multiple @change="onFileChanged" class="input-file">
                    <span style="cursor: pointer;">{{ $t('hotel.media.button.upload_photo') }}</span>
                </v-btn>
            </div>

            <draggable v-model="all_images" @start="drag_started_outside=false" @change="onChange()">
                <transition-group class="drag-flex-img">
                    <div v-for="(element,index) in all_images" :key="element.id" class="mx-1 image-div">
                        <img :src="element.url" class="image">
                        <div class="icons-div">
                            <v-icon class="mx-1 pa-1" size="28" color="red" @click="openDeleteDialog(index,element.id)">delete</v-icon>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </v-card-text>

        <v-card-actions class="align-end">
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text class="px-3 pt-5">
                {{ $t('hotel.media.message_delete_confimation') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" :loading="delete_loading" @click="destroy()">
                    {{ $t('button.delete') }}
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    {{ $t('button.cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

    <v-snackbar v-model="error_image" color="error" bottom left>
        {{ $t('hotel.modal.media.snackbar_error') }}
        <v-btn dark text @click="error_image = false">
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>

</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from '../../../../logger.js';
import draggable from 'vuedraggable';

const message = [
  "vue.draggable",
  "draggable",
  "component",
  "for",
  "vue.js 2.0",
  "based",
  "on",
  "Sortablejs"
];

export default {
    props: {
        dialog: Boolean,
        is_mounted: {
            type: Boolean,
            default: false
        },
        item: Object,
    },
    name: `hotel-media`,
    components: {
        draggable,
    },
    data() {
        return {
            error_image: false,
            files: [],
            // upload files settigs1
            delete_dialog: false,
            main_image_id: null,
            delete_loading: false,
            loading_save: false,
            drag_started_outside: true,
            all_images: this.item.static.images,
            images: [],
            unique_ids: [],
            default_image: null,
        };
    },

    watch: {

        'item.static.images': function (old_hotel, new_hotel) {
            this.unique_ids = [];
            this.images = [];
        },

        dialog: {
            immediate: true,
            handler: function (newdialog, olddialog) {
                if(newdialog) {
                    if(this.item.static.images.length) {
                        this.main_image_id = this.item.static.images[0].id;
                    } else {
                        this.main_image_id = null;
                    }
                }
            }
        },
    },
    computed: {},

    mounted() {
        const self = this;
        let dropzone = document.getElementById("dropzone");
        window.addEventListener("dragenter", function (e) {
            if(self.drag_started_outside) {
                dropzone.classList.remove("d-none");
            }
        });

        // window.addEventListener("dragleave", function (e) {
        //     e.preventDefault();
        //     dropzone.classList.add("d-none");
        // });
        this.$refs['dragzone'].addEventListener("dragleave", function (e) {
            e.preventDefault();
            dropzone.classList.add("d-none");
        });

        window.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        window.addEventListener("drop", function (e) {
            try {
                e.preventDefault();
                dropzone.classList.add("d-none");
                let image_types = ['image/png', 'image/jpg', 'image/jpeg'];
                let drag_files = e.target.files || e.dataTransfer.files;
                if(!drag_files.length) {
                    return;
                }
                Array.prototype.forEach.call(drag_files, file => {
                    if(image_types.includes(file.type)) {
                        self.createImage(file);
                    } else {
                        self.error_image = true;
                    }
                });
                drag_files = [];

            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/Hotel/items/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        })
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        onFileChanged(event) {
            try {
                const files = event.target.files || event.dataTransfer.files;
                if(!files.length) {
                    return;
                }
                Array.prototype.forEach.call(files, file => {
                    this.createImage(file);
                });
            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/Hotel/items/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        },
        generateUniqueId() {
            let nr_id = Math.floor((Math.random() * 10000) + 1);
            if(this.unique_ids.includes(nr_id)) {
                this.generateUniqueId();
            } else {
                this.unique_ids.push(nr_id)
                return nr_id
            }
        },

        createImage(file) {
            let id = this.generateUniqueId();
            try {
                const fileReader = new FileReader();
                fileReader.onload = event => {
                    this.images.push({
                        id: 'abc' + id,
                        caption: "",
                        default: false,
                        tag: "",
                        url: event.target.result
                    });
                    this.all_images.push({
                        id: 'abc' + id,
                        caption: "",
                        default: false,
                        tag: "",
                        url: event.target.result
                    });
                };
                fileReader.readAsDataURL(file);
            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/Hotel/modals/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        },

        openDeleteDialog(index, id) {
            let value = id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                this.status_photo = 'new';
                this.id_photo = id;
            } else {
                // photo is an old one and we need to call api
                this.id_photo = id;
                this.status_photo = 'old';
            }
            this.index_photo = index;
            this.delete_dialog = true;
        },

        deleteOldPhoto(file_id, index) {
            this.delete_loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            // call delete endpoint
            this.$axios.delete(endpoint + this.$route.params.id + "/delete-image/" + file_id)
                .then(response => {
                    this.success(this.$t('hotel.media.message_deleted_photo'));
                    this.all_images.splice(index, 1);
                    this.status_photo = null;
                    this.index_photo = null;
                    this.id_photo = null;
                    this.delete_loading = false;
                    this.delete_dialog = false;
                })
                .catch(error => {
                    this.delete_loading = false;
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {});

        },

        destroy() {
            if(this.status_photo == 'old') {
                this.deleteOldPhoto(this.id_photo, this.index_photo);
                return
            }
            if(this.status_photo == 'new') {
                // remove from Front
                this.all_images.splice(this.index_photo, 1);
                // remove from data for update hotel
                let value_index = this.images.findIndex(photo => photo.id === this.id_photo);
                this.images.splice(value_index, 1);
                this.status_photo = null;
                this.index_photo = null;
                this.id_photo = null;
                this.delete_dialog = false;
                this.success(this.$t('hotel.media.message_deleted_photo'));
                return
            }
        },

        onChange() {
            this.drag_started_outside = true;
            // this.$emit('updateDefaultPhoto', this.all_images[0].id);
        },

        emitExit() {
            this.unique_ids = [];
            this.images = [];
            this.main_image_id = null;
            this.$emit('exit');
        },

        changeMainImage() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";
            return this.$axios.post(endpoint + this.item.id + "/main-image/" + this.all_images[0].id)
                .then(response => {
                    this.success(this.$t('hotel.message_default_image'));
                    this.main_image_id == null;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});

        },

        async save() {
            this.loading_save = true;
            if(this.main_image_id && (this.all_images[0].id != this.main_image_id)) {
                let value = this.all_images[0].id.toString();
                if(!value.includes("abc")) {
                    await this.changeMainImage();
                }
            }

            if(this.images.length) {
                await this.saveNewImages();
            }
            this.loading_save = false;
            this.emitExit();
        },

        saveNewImages() {
            this.loading_save = true;
            // prepare some data for saving
            let save_images = this.$clone(this.images)
            save_images.map(image => delete image.id);
            let model = {
                static: {
                    images: save_images,
                }
            };
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = save_images;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            return this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    if(error.response.status === 413) {
                        this.error("Upload to high! Max 10Mb");
                    } else {
                        this.error("Oops, something went wrong!");
                    }
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

    },

};
</script>

<style lang="stylus">
.input-file
    opacity: 0
    /* invisible but it's there! */
    top: 0
    width: 100%
    height: 100%
    position: absolute
    cursor: pointer !important

.drag-flex-img
    display: flex
    flex-wrap: wrap

.sortable-ghost
    opacity: 0.2
    background: white

#dropzone
    position: fixed
    /* Sit on top of the page content */
    display: block
    /* Hidden by default */
    width: 100%
    /* Full width (cover the whole page) */
    height: 100%
    /* Full height (cover the whole page) */
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(0, 0, 0, 0.5)
    /* Black background with opacity */
    z-index: 5
    /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer
    /* Add a pointer on hover */

.text-dropzone
    height: 100%
    width: 100%
    display: flex
    color: white
    font-size: 40px
    align-items: center
    justify-content: center

.icons-div
    display: none
    position: absolute
    top: 5px
    right: 5px
    background-color: rgba(0, 0, 0, 0.4)
    border-radius: 50%
    
img
    &.image
        position: relative
        height: 200px
        width: auto
        max-width: 400px
        transition: 0.4s ease
        
.image-div
    transition: 0.4s ease
    position: relative
    min-width: 100px
    min-height: 100px
    &:hover
        .icons-div
            display: block
        img
            &.image
                filter: grayscale(70%)

</style>
